<template lang="html">
  <div class="p-4 row">

    <div class="col-lg-6 mb-4" v-for="(fieldset, i) in fieldsets[$store.state.lang]" :key="i">

      <div class="fs-14 fw-700 px-4 py-2 bg-light border-bottom border-dark">
        {{ fieldset.name }}
      </div>

      <div v-for="(field, i) in fieldset.fields" :key="i" class="pt-4 px-4 border-bottom border-secondary d-flex">
        <div class="mr-auto d-flex align-items-center">
          {{ field.name }}:
          <span v-if="$store.state.user_edit_field === field.attr">
            <span v-if="field.customer">
              <b-form-select v-if="field.variants" v-model="$store.state.user.customer[field.attr]" :options="field.variants"></b-form-select>
              <input v-else class="form-control border-0" type="text" v-model="$store.state.user.customer[field.attr]">
            </span>
            <input v-else class="form-control border-0" type="text" v-model="$store.state.user[field.attr]">
          </span>
          <span v-else class="pl-2 ml-1">
            <span v-if="field.customer">
              <span v-if="field.variants">
                {{ field.values[user.customer[field.attr]] }}
              </span>
              <span v-else>
                {{ user.customer[field.attr] }}
              </span>
            </span>
            <span v-else>
              {{ user[field.attr] }}
            </span>
          </span>
        </div>

        <button v-if="$store.state.user_edit_field !== field.attr" class="btn btn-link" @click="$store.commit('setData', {attr: 'user_edit_field', value: field.attr})">
          {{ t.change }}
        </button>
        <button v-if="$store.state.user_edit_field === field.attr" @click="$store.dispatch('updateAccount')" class="btn btn-link">
          {{ t.save }}
        </button>
        
      </div>


    </div>

    <!-- Manager: Period Statistics Settings -->
    <div class="col-lg-6 mb-4" v-if="$store.state.user && $store.state.user.customer && $store.state.user.customer.manager">
      <div class="fs-14 fw-700 px-4 py-2 bg-light border-bottom border-dark">
        {{ t.periodStatsTitle }}
      </div>
      <div class="pt-4 px-4 border-bottom border-secondary">
        <b-form-checkbox v-model="$store.state.user.customer.show_unmetered_web">
          {{ t.showUnmeteredWeb }}
        </b-form-checkbox>
      </div>
      <div class="pt-4 px-4 border-bottom border-secondary">
        <b-form-checkbox v-model="$store.state.user.customer.show_unmetered_xlsx">
          {{ t.showUnmeteredExcel }}
        </b-form-checkbox>
      </div>
      <div class="pt-4 px-4 border-bottom border-secondary">
        <b-form-checkbox v-model="$store.state.user.customer.show_unmetered_pdf">
          {{ t.showUnmeteredPdf }}
        </b-form-checkbox>
      </div>
      <div class="pt-4 px-4 border-bottom border-secondary">
        <b-form-checkbox v-model="$store.state.user.customer.highlight_de_enabled">
          {{ t.highlightTitle }}
        </b-form-checkbox>
        <div v-if="$store.state.user.customer.highlight_de_enabled" class="mt-3 d-flex align-items-center flex-wrap">
          <div class="mr-3 d-flex align-items-center mb-2">
            <span class="mr-2">{{ t.color }}</span>
            <input type="color" v-model="$store.state.user.customer.highlight_de_color" class="form-control form-control-color" style="width: 42px; height: 32px;"/>
          </div>
          <div class="mr-3 d-flex align-items-center mb-2">
            <span class="mr-2">{{ t.rangeFrom }}</span>
            <input type="number" step="0.001" class="form-control w-auto" v-model.number="$store.state.user.customer.highlight_de_min"/>
          </div>
          <div class="mr-3 d-flex align-items-center mb-2">
            <span class="mr-2">{{ t.rangeTo }}</span>
            <input type="number" step="0.001" class="form-control w-auto" v-model.number="$store.state.user.customer.highlight_de_max"/>
          </div>
          <div v-if="validHighlightRange" class="mt-2 mb-2">
            <span class="px-2 py-1 rounded" :style="{ backgroundColor: $store.state.user.customer.highlight_de_color || '#ffd' }">
              ΔQ: {{$store.state.user.customer.highlight_de_min}} - {{$store.state.user.customer.highlight_de_max}}
            </span>
          </div>
        </div>
      </div>
      <div class="pt-3 px-4">
        <button class="btn btn-link p-0" @click="$store.dispatch('updateAccount')">{{ t.save }}</button>
      </div>
    </div>

    <!-- Telegram Accounts Management -->
    <div class="col-lg-12 mb-4">
      <div class="fs-14 fw-700 px-4 py-2 bg-light border-bottom border-dark">
        {{ t.telegramAccountsTitle }}
      </div>
      <div class="pt-4 px-4">
        <div v-if="telegramAccounts.length > 0" class="table-responsive">
          <table class="table table-sm">
            <thead>
              <tr>
                <th>{{ t.telegramAccount }}</th>
                <th>{{ t.telegramId }}</th>
                <th>{{ t.dateAdded }}</th>
                <th class="text-right">{{ t.actions }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="account in telegramAccounts" :key="account.id">
                <td>
                  <a :href="account.telegram_link" target="_blank" class="text-primary">
                    {{ account.display_name }}
                  </a>
                </td>
                <td>{{ account.telegram_id }}</td>
                <td>{{ formatDate(account.created_at) }}</td>
                <td class="text-right">
                  <b-button 
                    variant="outline-primary" 
                    size="sm"
                    @click="testTelegramNotification(account.id)"
                    :disabled="loading"
                    class="mr-2">
                    {{ t.testButton }}
                  </b-button>
                  <b-button 
                    variant="outline-danger" 
                    size="sm"
                    @click="unlinkTelegramAccount(account.id)">
                    {{ t.unlinkTelegramButton }}
                  </b-button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div v-else class="text-muted py-3">
          {{ t.noTelegramAccounts }}
        </div>
        <div class="pt-3">
          <b-button 
            v-if="telegramAccounts.length < 10"
            variant="outline-primary" 
            @click="linkTelegram"
            :disabled="loading">
            {{ t.linkTelegramButton }}
          </b-button>
          <div v-else class="text-muted small">
            {{ t.maxAccountsReached }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    t () {
      return this.i18n[this.$store.state.lang]
    },
    user () {
      return this.$store.state.user
    },
    validHighlightRange () {
      const c = this.$store.state.user && this.$store.state.user.customer
      if (!c) return false
      const hasAll = c.highlight_de_color && (c.highlight_de_min !== null && c.highlight_de_min !== undefined) && (c.highlight_de_max !== null && c.highlight_de_max !== undefined)
      return hasAll && Number(c.highlight_de_max) > Number(c.highlight_de_min)
    }
  },
  data () {
    return {
      editingLimitValue: '',
      telegramAccounts: [],
      loading: false,
      telegramBotName: '@Teplomer_informer_bot', // Default, will be loaded from API
      i18n: {
        ru: {
          change: 'Изменить',
          save: 'Сохранить',
          periodStatsTitle: 'Статистика за период',
          showUnmeteredWeb: 'Отображать помещения без счетчиков на WEB-странице',
          showUnmeteredExcel: 'Отображать помещения без счетчиков в Excel отчете',
          showUnmeteredPdf: 'Отображать помещения без счетчиков в PDF отчете',
          highlightTitle: 'Подсвечивать строки по диапазону ΔQ (Гкал) на WEB-странице',
          color: 'Цветом',
          rangeFrom: 'Начальное значение',
          rangeTo: 'Конечное значение',
          linkTelegramButton: 'Связать Telegram',
          telegramLinkedStatus: '✓ Telegram связан',
          unlinkTelegramButton: 'Отвязать',
          linkTelegramTitle: 'Связать Telegram',
          linkTelegramHeading: 'Связывание Telegram аккаунта',
          linkTelegramStepBot: 'Открылась ссылка на Telegram-бота',
          linkTelegramStepStart: 'Нажмите "START" в боте для мгновенного связывания',
          linkTelegramManual: 'Если ссылка не открылась, найдите бота вручную',
          linkTelegramBotName: '@Teplomer_informer_bot',
          linkTelegramOk: 'Понятно',
          linkTelegramError: 'Ошибка при получении ссылки',
          telegramIdLabel: 'Telegram ID',
          unlinkTelegramConfirm: 'Вы уверены, что хотите отвязать Telegram? Уведомления о лимитах перестанут приходить.',
          unlinkTelegramSuccess: 'Telegram отвязан',
          unlinkTelegramError: 'Ошибка при отвязке Telegram',
          testButton: 'Тест',
          testNotificationSuccess: 'Тестовое уведомление отправлено',
          testNotificationError: 'Ошибка при отправке тестового уведомления',
          telegramAccountsTitle: 'Telegram аккаунты для уведомлений',
          telegramAccount: 'Аккаунт',
          telegramId: 'Telegram ID',
          dateAdded: 'Дата добавления',
          actions: 'Действия',
          noTelegramAccounts: 'Нет привязанных Telegram аккаунтов',
          maxAccountsReached: 'Достигнуто максимальное количество привязанных аккаунтов (10)'
        },
        ua: {
          change: 'Змінити',
          save: 'Зберегти',
          periodStatsTitle: 'Статистика за період',
          showUnmeteredWeb: 'Відображати приміщення без лічильників на WEB-сторінці',
          showUnmeteredExcel: 'Відображати приміщення без лічильників в Excel-звіті',
          showUnmeteredPdf: 'Відображати приміщення без лічильників у PDF-звіті',
          highlightTitle: 'Підсвічувати рядки за діапазоном ΔQ (Гкал) на WEB-сторінці',
          color: 'Кольором',
          rangeFrom: 'Початкове значення',
          rangeTo: 'Кінцеве значення',
          linkTelegramButton: 'Прив’язати Telegram',
          telegramLinkedStatus: '✓ Telegram пов’язаний',
          unlinkTelegramButton: 'Відв’язати',
          linkTelegramTitle: 'Прив’язати Telegram',
          linkTelegramHeading: 'Прив’язування Telegram-акаунта',
          linkTelegramStepBot: 'Відкрито посилання на Telegram-бота',
          linkTelegramStepStart: 'Натисніть "START" у боті для миттєвого прив’язування',
          linkTelegramManual: 'Якщо посилання не відкривається, знайдіть бота вручну',
          linkTelegramBotName: '@Teplomer_informer_bot',
          linkTelegramOk: 'Зрозуміло',
          linkTelegramError: 'Помилка під час отримання посилання',
          telegramIdLabel: 'Telegram ID',
          unlinkTelegramConfirm: 'Ви впевнені, що хочете відв’язати Telegram? Сповіщення про ліміти перестануть надходити.',
          unlinkTelegramSuccess: 'Telegram відв\'язано',
          unlinkTelegramError: 'Помилка під час відв\'язування Telegram',
          testButton: 'Тест',
          testNotificationSuccess: 'Тестове сповіщення відправлено',
          testNotificationError: 'Помилка під час відправки тестового сповіщення',
          telegramAccountsTitle: 'Telegram акаунти для сповіщень',
          telegramAccount: 'Акаунт',
          telegramId: 'Telegram ID',
          dateAdded: 'Дата додавання',
          actions: 'Дії',
          noTelegramAccounts: 'Немає прив’язаних Telegram акаунтів',
          maxAccountsReached: 'Досягнуто максимальну кількість прив’язаних акаунтів (10)'
        }
      },
      fieldsets: {
        ru: [
          {
            name: 'Личные данные',
            fields: [
              {name: 'Фамилия', attr: 'last_name'},
              {name: 'Имя', attr: 'first_name'},
              {name: 'Отчество', attr: 'patronymic', customer: true},
              {name: 'Название организации', attr: 'company_name', customer: true},
              {
                name: 'Язык аккаунта',
                attr: 'lang',
                customer: true,
                variants: [
                  { text: 'Русский', value: 'ru' },
                  { text: 'Украинский', value: 'ua' },
                ],
                values: {
                  ua: 'Украинский',
                  ru: 'Русский'
                }
              },
            ],
          },
          {
            name: 'Контакты для оповещения',
            fields: [
              {name: 'Моб. телефон', attr: 'phone', customer: true},
              {name: 'E-mail', attr: 'email'},
            ]
          },
        ],
        ua: [
          {
            name: 'Особисті дані',
            fields: [
              {name: 'Прізвище', attr: 'last_name'},
              {name: "Ім'я", attr: 'first_name'},
              {name: 'По-батькові', attr: 'patronymic', customer: true},
              {name: 'Назва організації', attr: 'company_name', customer: true},
              {
                name: 'Мова облікового запису',
                attr: 'lang',
                customer: true,
                variants: [
                  { text: 'Русский', value: 'ru' },
                  { text: 'Український', value: 'ua' },
                ],
                values: {
                  ua: 'Український',
                  ru: 'Русский'
                }
              },
            ],
          },
          {
            name: 'Контакти для оповіщення',
            fields: [
              {name: 'Моб. телефон', attr: 'phone', customer: true},
              {name: 'E-mail', attr: 'email'},
            ]
          },
        ]
      },
    }
  },
  mounted() {
    this.loadTelegramAccounts()
    this.loadTelegramBotName()
  },
  methods: {
    async loadTelegramBotName() {
      try {
        const response = await this.$http.get('/api/telegram/bot_name', {
          headers: {
            'X-CSRFToken': this.getCsrfToken()
          }
        })
        if (response.body && response.body.bot_name_with_at) {
          this.telegramBotName = response.body.bot_name_with_at
        }
      } catch (error) {
        console.error('Error loading Telegram bot name:', error)
      }
    },
    
    async loadTelegramAccounts() {
      try {
        const response = await this.$http.get('/api/telegram/accounts', {
          headers: {
            'X-CSRFToken': this.getCsrfToken()
          }
        })
        if (response.body && response.body.accounts) {
          this.telegramAccounts = response.body.accounts
        }
      } catch (error) {
        console.error('Error loading Telegram accounts:', error)
      }
    },
    
    async linkTelegram() {
      try {
        // Get Telegram link
        const response = await this.$http.post('/api/telegram/link', {
          action: 'get_link'
        }, {
          headers: {
            'X-CSRFToken': this.getCsrfToken()
          }
        })
        
        if (response.body.telegram_link) {
          // Open Telegram directly
          window.open(response.body.telegram_link, '_blank')
          
          // Show confirmation dialog
          this.$bvModal.msgBoxOk(
          this.renderTelegramMessage(),
            {
              title: this.t.linkTelegramTitle,
            okTitle: this.t.linkTelegramOk
            }
          ).finally(() => {
            this.loadTelegramAccounts()
          })
        }
      } catch (error) {
        this.$toasted.error(this.t.linkTelegramError)
      }
    },
    
    async testTelegramNotification(accountId) {
      this.loading = true
      try {
        const response = await this.$http.post(`/api/telegram/test/${accountId}`, {}, {
          headers: {
            'X-CSRFToken': this.getCsrfToken()
          }
        })
        
        if (response.body && response.body.success) {
          this.$toasted.success(this.t.testNotificationSuccess)
        } else {
          this.$toasted.error(response.body?.error || this.t.testNotificationError)
        }
      } catch (error) {
        this.$toasted.error(this.t.testNotificationError)
        console.error('Error sending test notification:', error)
      } finally {
        this.loading = false
      }
    },
    
    async unlinkTelegramAccount(accountId) {
      if (confirm(this.t.unlinkTelegramConfirm)) {
        try {
          await this.$http.post(`/api/telegram/unlink/${accountId}`, {}, {
            headers: {
              'X-CSRFToken': this.getCsrfToken()
            }
          })
          
          // Reload accounts list
          await this.loadTelegramAccounts()
          
          this.$toasted.success(this.t.unlinkTelegramSuccess)
        } catch (error) {
          this.$toasted.error(this.t.unlinkTelegramError)
        }
      }
    },
    
    formatDate(dateString) {
      if (!dateString) return ''
      const date = new Date(dateString)
      return date.toLocaleDateString(this.$store.state.lang === 'ua' ? 'uk-UA' : 'ru-RU', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
      })
    },
    
    renderTelegramMessage() {
      const h = this.$createElement
      return h(
        'div',
        { class: 'text-left' },
        [
          h('strong', this.t.linkTelegramHeading),
          h('br'),
          h('br'),
          h('div', [
            '📱 ',
            this.t.linkTelegramStepBot
          ]),
          h('div', [
            '🤖 ',
            this.t.linkTelegramStepStart
          ]),
          h('br'),
          h('small', [
            `${this.t.linkTelegramManual} `,
            h('strong', this.telegramBotName)
          ])
        ]
      )
    },

    getCsrfToken() {
      const cookies = document.cookie.split(';')
      for (let cookie of cookies) {
        const [name, value] = cookie.trim().split('=')
        if (name === 'csrftoken') {
          return decodeURIComponent(value)
        }
      }
      return ''
    }
  }
}
</script>

<style lang="css" scoped>
.cursor-pointer {
  cursor: pointer;
}
</style>
